import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  return (
    <div
      className="min-h-screen bg-[#050505] flex items-center justify-center px-6"
      data-testid="payment-cancel-page"
    >
      <div className="glass p-10 rounded-2xl max-w-lg w-full border border-white/10 text-center">
        <div className="w-20 h-20 bg-red-500/15 border border-red-500/40 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-400" />
        </div>
        <h1 className="text-3xl font-headline font-bold text-white mb-3">Payment cancelled</h1>
        <p className="text-[#A1A1AA] font-body mb-8">
          No charge was made. Whenever you're ready, come back to pricing and pick a plan.
        </p>
        <Link to="/ongoing-support">
          <Button className="bg-[#00E599] hover:bg-[#00C985] text-[#050505] font-bold">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Pricing
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
